import React from 'react';
import { Phone, Mail, CheckCircle2, ShieldCheck, Award } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-brand-dark overflow-hidden" data-id="element-192">
      {/* Background subtle pattern/glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl opacity-20 pointer-events-none" data-id="element-193">
        <div className="absolute top-20 left-10 w-96 h-96 bg-brand-gold rounded-full blur-[120px]" data-id="element-194"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-195">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-196">
          {/* Text Content */}
          <div className="lg:col-span-6 lg:pr-8" data-id="element-197">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-198">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-gold/10 border border-brand-gold/20 text-brand-gold text-sm font-semibold mb-6" data-id="element-199">
                <Award className="w-4 h-4" data-id="element-200" />
                <span data-id="element-201">{t('hero.badge')}</span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6 text-balance" data-id="element-202">
                {t('hero.title')}
              </h1>

              <p className="text-lg sm:text-xl text-white/80 mb-8 font-medium leading-relaxed text-balance" data-id="element-203">
                {t('hero.subtitle')}
              </p>

              {/* Trust Badges */}
              <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-204">
                <div className="flex items-center gap-2 text-white/90" data-id="element-205">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-206" />
                  <span className="text-sm font-medium" data-id="element-207">
                    {t('hero.trust1')}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-white/90" data-id="element-208">
                  <ShieldCheck className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-209" />
                  <span className="text-sm font-medium" data-id="element-210">
                    {t('hero.trust2')}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-white/90" data-id="element-211">
                  <Award className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-212" />
                  <span className="text-sm font-medium" data-id="element-213">
                    {t('hero.trust3')}
                  </span>
                </div>
              </div>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-214">
                <a href="tel:8137534656" className="flex items-center justify-center gap-2 bg-brand-gold hover:bg-brand-goldLight text-brand-black px-8 py-4 rounded font-bold text-lg transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,164,55,0.3)]" data-id="element-215">
                  <Phone className="w-5 h-5" data-id="element-216" />
                  <span data-id="element-217">{t('hero.cta1')}</span>
                </a>
                <a href="mailto:jomeliteconstruction@gmail.com" className="flex items-center justify-center gap-2 bg-transparent border-2 border-white/20 hover:border-brand-gold text-white px-8 py-4 rounded font-bold text-lg transition-all hover:bg-white/5" data-id="element-218">
                  <Mail className="w-5 h-5" data-id="element-219" />
                  <span data-id="element-220">{t('hero.cta2')}</span>
                </a>
              </div>
            </motion.div>
          </div>

          {/* Image */}
          <div className="lg:col-span-6 relative" data-id="element-221">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10" data-id="element-222">
              <img src="https://cdn.magicpatterns.com/uploads/eMKrXC3836F9SUfpe8Ljc3/heylloyd-image-1780768271075.png" alt="Equipo JOM Elite Construction" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-auto lg:h-[600px]" data-id="element-223" />

              {/* Overlay Badge */}
              <div className="absolute -bottom-6 left-6 right-6 sm:right-auto bg-brand-black/90 backdrop-blur-sm border border-brand-gold/30 p-4 rounded-xl flex items-center gap-4 shadow-xl" data-id="element-224">
                <div className="bg-brand-gold/20 p-3 rounded-full" data-id="element-225">
                  <ShieldCheck className="w-8 h-8 text-brand-gold" data-id="element-226" />
                </div>
                <div data-id="element-227">
                  <p className="text-white font-bold text-lg leading-tight" data-id="element-228">
                    {t('hero.overlayTitle')}
                  </p>
                  <p className="text-white/70 text-sm" data-id="element-229">
                    {t('hero.overlaySub')}
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}